/**
 * @license Givaudan. All rights reserved
 * @author Ayoub MHAMDI
 */

import { RequestStatus } from '@banyan/commons/enum/request-status';

import { RequestStatusV2 } from '../enum/request-status-v2';
import { Request, RequestV2 } from '../models/request.model';
import { RequestsResponse, RequestsResponseV2 } from '../models/requests-response.model';

export function RequestsDto(response: RequestsResponse): RequestsResponse {
  const modifiedRequests: Request[] = [];

  response.requests.forEach(request => {
    let statusCode;
    let statusTranslationKey;

    switch (request.statusCode) {
      case 5:
        statusCode = RequestStatus.expired;
        statusTranslationKey = 'request.status-no-longer-valid';
        break;
      case 7:
        statusCode = RequestStatus.requestSubmitted;
        statusTranslationKey = 'request.status-submitted';
        break;
      default:
        statusCode = RequestStatus.fragranceProposal;
        statusTranslationKey = 'request.status-proposal';
        break;
    }
    modifiedRequests.push({
      ...request,
      statusCode: statusCode,
      status: statusTranslationKey,
    });
  });

  return {
    requests: modifiedRequests,
    count: response.count,
    offset: response.offset,
    limit: response.limit,
  };
}

export function RequestsDtoV2(response: RequestsResponseV2): RequestsResponseV2 {
  const modifiedRequests: RequestV2[] = [];

  response.requests.forEach(request => {
    let statusCode;
    let statusTranslationKey;

    switch (request.status) {
      case 'new':
        statusCode = RequestStatusV2.new;
        statusTranslationKey = 'request.status-submitted';
        break;
      case 'proposal':
        statusCode = RequestStatusV2.proposal;
        statusTranslationKey = 'request.status-proposal';
        break;
      case 'update_requested':
        statusCode = RequestStatusV2.updateRequested;
        statusTranslationKey = 'request.status-proposal';
        break;
      default:
        statusCode = RequestStatusV2.expired;
        statusTranslationKey = 'request.status-no-longer-valid';
        break;
    }
    modifiedRequests.push({
      ...request,
      status: statusCode,
      statusTranslation: statusTranslationKey,
    });
  });

  return {
    requests: modifiedRequests,
    pagination: response.pagination
  };
}